// src/components/common/ToastManager.jsx
import React, { useState } from 'react';
import ToastNotification from './ToastNotification';
import '../../styles/ToasterManager.css';

// Ensure a global queue exists early so components can call showToast
if (typeof window !== 'undefined') {
  window._toastQueue = window._toastQueue || [];
  if (!window.showToast) {
    window.showToast = (message, statusCode) => {
      window._toastQueue.push({ message, statusCode });
    };
  }
}

const ToastManager = () => {
  const [toasts, setToasts] = useState([]);
  
  // Function to add a new toast
  const addToast = (message, statusCode) => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, statusCode }]);
  };
  
  // Function to remove a toast
  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };
  
  // Expose the addToast function globally
  React.useEffect(() => {
    // Mount: set global showToast to addToast and flush queued messages
    window.showToast = addToast;
    if (window._toastQueue && window._toastQueue.length > 0) {
      window._toastQueue.forEach((t) => addToast(t.message, t.statusCode));
      window._toastQueue = [];
    }

    return () => {
      // Unmount: remove the global fn but keep queue for future mounts
      try { delete window.showToast; } catch (e) { window.showToast = undefined; }
    };
  }, []);
  
  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <ToastNotification
          key={toast.id}
          message={toast.message}
          statusCode={toast.statusCode}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

export default ToastManager;